import React, { useState, useEffect, useContext, useCallback, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Modal } from 'syngenta-react-components'
import '../../dpe-usco/components/Table/Table.scss'
import {
  getRolesAndPermissions,
  getAllPermissions,
  getHighestRole
} from '../../services/apiHelper'
import checked from '../../assets/icons/circle_check_green.svg'
import unChecked from '../../assets/icons/circle_empty.svg'
import DefaultSalesYearForm from '../../components/ModalForms/DefaultSalesYearForm'
import NewRoleForm from '../../components/ModalForms/NewRoleForm'
import EditRoleForm from '../../components/ModalForms/EditRoleForm'
import NewAdminForm from '../../components/ModalForms/NewAdminForm'
import { AuthContext, GlobalContext } from '../../services/context'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import DetailCardWithTable from '../../dpe-usco/components/Details/DetailCardWithTable'
import { convertToTitleCase } from '../../services/utils'

const Admin = () => {
  const { state, trackEvent } = useContext(GlobalContext)
  const [rowData, setRowData] = useState([])
  const [roleName, setRoleName] = useState()
  const [showModal, setShowModal] = useState(false)
  const [getData, setGetData] = useState(true)
  const [modalContent, setModalContent] = useState()
  const { hasAccess } = useContext(AuthContext)
  const [accessState, setAccessState] = useState('LOADING')
  const history = useHistory()
  const [uploadLinkedBtn, setUploadLinkedBtn] = useState(false)
  const [isProgramsPermission, setIsProgramsPermission] = useState(false)

  const canceled = useRef(false)
  useEffect(() => {

    return () => {
      canceled.current = true
    }
  }, [])

  const handleEditRoleModal = useCallback(
    e => {
      e.preventDefault()
      e.stopPropagation()
      setShowModal(true)
      setModalContent('edit')
      trackEvent('edit_role_clicked', { roleName })
    },
    [trackEvent, roleName]
  )

  useEffect(() => {
    const initRoles = () => {
      getRolesAndPermissions().then(res => {
        getAllPermissions().then(res2 => {
          const comparedData = res.map(role => {
            if (typeof role.permissions != 'string') {
              const permissions = res2.map(permission => {
                if (role.permissions.includes(permission.permission_code)) {
                  return {
                    display_name: permission.permission_display_name,
                    permission: permission.permission_code,
                    role_id: role.role_id,
                    role_name: role.role_name,
                    role_type: role.role_type,
                    isMatching: true
                  }
                } else {
                  return {
                    display_name: permission.permission_display_name,
                    permission: permission.permission_code,
                    role_id: role.role_id,
                    role_name: role.role_name,
                    role_type: role.role_type,
                    isMatching: false
                  }
                }
              })
              const output = {
                role_name: role.role_name,
                role_type: role.role_type,
                date_created: role.date_created,
                subRowContent: customSubRow(permissions),
                permissionsData: permissions
              }
              return output
            }
            return {
              role_name: role.role_name,
              role_type: role.role_type,
              date_created: role.date_created,
              permissions: role.permissions,
              subRowContent: res2
            }
          })
          const alphabeticalData = [...comparedData]
          alphabeticalData.sort((a, b) => {
            return a.role_name > b.role_name ? 1 : -1
          })
          if(!canceled.current){
            setRowData(() => {
              return alphabeticalData
            })
          }
        })
      })
    }
    initRoles()
    const customSubRow = options => {
      const roles = options.map(role => {
        return (
          <div
            data-testid="customSubRow"
            key={role.permission}
            className="df fxdrc aic w200 ml20 mt20"
          >
            {formatCircles(role.isMatching)}
            <span className="tac fz15">{role.display_name}</span>
          </div>
        )
      })
      return [
        <div key="unique">
          <div className="df fxww">{roles}</div>
          <div className="df jcfe">
            <Button
              type="success"
              text="Edit"
              customClassName="mr20"
              clickHandler={handleEditRoleModal}
            />
          </div>
        </div>
      ]
    }
  }, [setRowData, getData, handleEditRoleModal])

  const mapHeaders = headerArray => {
    return headerArray.map(header => {
      return {
        value: header,
        format() {
          return headerCell(header)
        }
      }
    })
  }
  const headerCell = value => {
    return (
      <div key={value} className={`${value} cell`}>
        <div>{value}</div>
      </div>
    )
  }
  const RolesHeaders = ['Role name', 'Role type', 'Date created']

  const clickRole = rowContent => {
    setRoleName(rowContent.role_name)
  }

  const structure = {
    headers: mapHeaders(RolesHeaders),
    dataKeys: ['role_name', 'role_type', 'date_created'],
    rowKey: 'role_name',
    hasSubRow: true,
    hasIcon: true,
    dropdownCallback: clickRole,
    rowFormat: {
      role_name: {
        format: obj => {
          return <div>{convertToTitleCase(obj)}</div>
        }
      }
    }
  }

  const handleNewRoleModal = () => {
    setShowModal(true)
    setModalContent('add_role')
    trackEvent('add_roles_clicked')
  }

  const handleInviteAdmin = () => {
    setShowModal(true)
    setModalContent('invite_admin')
    trackEvent('invite_admin_clicked')
  }

  const handleSalesYear = () => {
    setShowModal(true)
    setModalContent('change_sales_year')
  }
  const createNewScaleTicket = () => {
    history.push('/company/upload-companies-training/')
  }
  const uploadTrainingVideo = () => {
    history.push('/company/upload-training-video/')
  }
  const uploadAccountLeads =() => {
    history.push('/company/upload-account-leads/')
  }
  const programs = () => {
    history.push('/company/programs/')
  }
  
  useEffect(() => {
    if (getData) {
      setGetData(false)
    }
  }, [getData, setGetData])

  const subRowStructure = {
    headers: ['Entire Row'],
    dataKeys: ['entireRow'],
    customContent: true
  }

  const formatCircles = val => {
    if (val === true) {
      return <img className="aifs mb5" alt="checked circle" src={checked} />
    }
    if (val === false) {
      return <img className="aifs mb5" alt="unchecked circle" src={unChecked} />
    }
  }

  const modalDecider = () => {
    switch (modalContent) {
      case 'edit':
        return (
          <EditRoleForm
            handleClose={() => setShowModal(false)}
            handleDataRefresh={() => setGetData(true)}
            permisisonsData={rowData}
            roleName={roleName}
          />
        )
      case 'add_role':
        return (
          <NewRoleForm
            handleClose={() => setShowModal(false)}
            handleDataRefresh={() => setGetData(true)}
            permisisonsData={rowData}
          />
        )
      case 'invite_admin':
        return <NewAdminForm handleCancel={() => setShowModal(false)} />
      case 'change_sales_year':
        return <DefaultSalesYearForm  handleClose={() => setShowModal(false)} />  
      default:
        return (<></>)
    }
  }

  useEffect(() => {
    setAccessState(hasAccess())
  }, [hasAccess])

  useEffect(() => {
    getHighestRole()?.then(res => {
      if (res.permissions.includes('update-EAL-bulk')) {
        setUploadLinkedBtn(true)
      } else {
        setUploadLinkedBtn(false)
      }
      if(res.permissions.includes('show-programs')){
        setIsProgramsPermission(true)
      }else{
        setIsProgramsPermission(false)
      }
    })
  }, [state?.userPermission?.hasChanged])

  return (
    <div>
      {hasAccess() === 'SUCCESS' ? (
        <div className="ml25 mr25">
          <div className="df w100% jcfe">
            <div className="df aife">
              <div>
                { isProgramsPermission && <Button
                  type="outline"
                  text='Programs'
                  customClassName="mr20"
                  clickHandler={programs}
                /> }
              </div>
              <div>
                { uploadLinkedBtn && <Button
                  type="outline"
                  text='Upload Account Leads'
                  customClassName="mr20"
                  clickHandler={uploadAccountLeads}
                /> }
              </div>
              <div>
                <Button
                  type="outline"
                  text='Upload Training Video'
                  customClassName="mr20"
                  clickHandler={uploadTrainingVideo}
                />
              </div>
              <div  data-testid="uploadStewardshipTraining">
                <Button
                  type="outline"
                  text='Upload Stewardship Training'
                  customClassName="mr20"
                  clickHandler={createNewScaleTicket}
                />
              </div>
  
              <div data-testid="setSalesYearButton">
                <Button
                  text="Set default contract year"
                  type="outline"
                  customClassName="mr20"
                  clickHandler={handleSalesYear}
                />
              </div>
              <div data-testid="addRolesButton" className='h100%'>
                <Button
                  text="Add roles"
                  type="success"
                  customClassName="mr20"
                  clickHandler={handleNewRoleModal}
                />
              </div>
              <div data-testid="inviteAdminButton" className='h100%'>
                <Button
                  text="Invite admin"
                  type="success"
                  clickHandler={handleInviteAdmin}
                />
              </div>
            </div>
          </div>
          <div data-testid="adminTable">
            <DetailCardWithTable
              title="Roles"
              structure={structure}
              subRowStructure={subRowStructure}
              data={rowData}
              dropdownCallback={structure.dropdownCallback}
            />
          </div>
          {showModal &&
          <div data-testid="adminModal">
            <Modal
              autoHeight
              show={showModal}
              handleClose={() => setShowModal(false)}
            >
              {modalDecider()}
            </Modal>
          </div>
          }
        </div>
      ) : accessState === 'LOADING' ? (
        <TableStatus status="LOADING" />
      ) : (
        <>
          <h1>Whoops!</h1>
          <h3>You don‘t have the right permissions to view this page.</h3>
        </>
      )}
    </div>
  )
}

export default Admin
